
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { configStore, documentStore, uiStore } from "@/store/store";
import { loadAllDynamicDataFromTreeIntoStore } from "@/lib/dynamic-data/load";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import IconButton from "@/components/UI/IconButton.vue";
import lodash from "lodash";
import { TemplatePreviewableItem } from "@/types/templates";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import { fetchTemplatePreviewableItems } from "@/lib/dynamic-data/templates";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import NotificationLogger from "@/lib/notifications/notifications";
import Icon from "@/components/UI/Icon.vue";
import { saveLastPreviewedItemInWp } from "@/lib/wordpress/load";

@Component({
  components: { Icon, Dropdown, IconButton, TopBarSection }
})
export default class PreviewContentChooserDialog extends Vue {
  open = false;
  search = "";
  isLoading = false;

  get previews() {
    return (
      configStore.templatePreview &&
      configStore.templatePreview.previewableItems
    );
  }

  get currentPreviewedItem() {
    return configStore.previewedItem;
  }

  get nothingToPreviewAndNoSearchQueryAndNotLoading() {
    return (
      (!this.previews || !this.previews.length) &&
      !this.search &&
      !this.isLoading
    );
  }

  async setPreviewedItem(newItem: TemplatePreviewableItem) {
    this.open = false;

    // All elements should SSR when changing preview
    uiStore.setLastModifiedElementProperty({ elementId: null, path: null });
    configStore.setPreviewedItem(newItem);
    configStore.flushDynamicDataCache();
    await loadAllDynamicDataFromTreeIntoStore();

    saveLastPreviewedItemInWp(newItem);
  }

  async handleSearch(searchValue: string) {
    this.search = searchValue;
    this.isLoading = true;
    this.debouncedSearchContentInWp();
  }

  debouncedSearchContentInWp = lodash.debounce(this.searchContentInWp, 300);

  async searchContentInWp() {
    this.isLoading = true;

    pipe(
      await fetchTemplatePreviewableItems({
        search: this.search,
        id: documentStore.document.documentMeta.id
      }),
      fold(
        errors => {
          this.isLoading = false;
          errors.forEach(e => NotificationLogger.log.message(e.msg));
        },
        templatePreviewableItems => {
          configStore.setTemplatePreview({
            ...configStore.templatePreview,
            previewableItems: templatePreviewableItems
          });

          this.isLoading = false;
        }
      )
    );
  }
}
